<template>
    <div class="transaction-confirmation__container">
        <div class="notice">
            {{ $t(message) | capitalize }}
        </div>
        <template v-if="isSuccessful">
            <Illustration xl image="/static/img/illustrations/deposit__success.svg"/>
        </template>
        <template v-else>
            <Illustration xl image="/static/img/illustrations/deposit__error.svg"/>
        </template>
    </div>
</template>

<script>
    import eventChannel from '@core/tracking/EventChannel';
    import Topic from '@core/tracking/Topic';
    import { DEPOSIT } from '@core/tracking/Events';

    export default {
        name: 'PaymentGatewayStatusContainer',
        created() {
            eventChannel.publish(Topic.analytics, {
                event: DEPOSIT,
                depositStatus: this.status,
            });
        },
        computed: {
            status() {
                return this.$router.currentRoute.query.transactionStatus;
            },
            isSuccessful() {
                return this.status === 'success';
            },
            message() {
                const status = this.$router.currentRoute.query.transactionStatus;
                const messages = {
                    success: 'transaction succeed',
                    pending: 'transaction pending',
                    failure: 'transaction failed',
                    cancel: 'transaction canceled',

                };
                return messages[status];
            }
        },
    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/app/modules/userProfile/paymentGateway/PaymentGatewayStatusContainer.vue